<template>
    <!-- in place of a break-screen slide while its data loads: its card with its title, the body still to come -->
    <broadcast-card :eyebrow="eyebrow" :title="title">
        <div class="slide-placeholder">
            <div v-for="row in 5" :key="row" class="slide-placeholder__row">
                <span class="slide-placeholder__block slide-placeholder__block--short" />
                <span class="slide-placeholder__block" />
                <span class="slide-placeholder__block slide-placeholder__block--short" />
            </div>
        </div>
    </broadcast-card>
</template>

<script>
    import BroadcastCard from '@/components/BroadcastCard'

    // the head of each slide, as its own card shows it
    const HEADS = {
        'past-meetings': ['Πριν τον αγώνα', 'Προηγούμενες αναμετρήσεις'],
        standings: ['', 'Βαθμολογία'],
        players: ['Πριν τον αγώνα', 'Παίκτες που ξεχωρίζουν'],
        teams: ['Πριν τον αγώνα', 'Μέσοι όροι σεζόν'],
        mvp: ['Τέλος αγώνα', 'MVP του αγώνα'],
        stats: ['Στατιστικά αγώνα', 'Σύγκριση ομάδων'],
        'score-evolution': ['Στατιστικά αγώνα', 'Εξέλιξη σκορ'],
        'shooting-team1': ['', 'Χάρτης σουτ'],
        'shooting-team2': ['', 'Χάρτης σουτ']
    }

    export default {
        name: 'SlidePlaceholder',
        components: {
            BroadcastCard
        },
        props: {
            slide: {
                type: String,
                required: true
            },
            match: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            eyebrow() {
                // the shooting charts are headed by their team
                if (this.slide === 'shooting-team1' || this.slide === 'shooting-team2') {
                    const team = this.match[this.slide === 'shooting-team1' ? 'team1' : 'team2']
                    return (team && team.name) || ''
                }
                return (HEADS[this.slide] || [])[0] || ''
            },
            title() {
                return (HEADS[this.slide] || [])[1] || ''
            }
        }
    }
</script>

<style scoped>
.slide-placeholder {
    display: flex;
    flex-direction: column;
    gap: 22px;
    height: 520px;
    padding-top: 10px;
}

.slide-placeholder__row {
    display: flex;
    gap: 24px;
}

.slide-placeholder__block {
    flex: 1;
    height: 72px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.14) 40%, rgba(255, 255, 255, 0.06) 80%);
    background-size: 300% 100%;
    animation: slide-placeholder-shimmer 1.4s ease-in-out infinite;
}

.slide-placeholder__block--short {
    flex: 0 0 160px;
}

@keyframes slide-placeholder-shimmer {
    from {
        background-position: 100% 0;
    }

    to {
        background-position: 0 0;
    }
}
</style>
